import React, { useEffect } from "react";
import { useStore } from "../../store/store";
import fractionToInt from "../../util/fractionToInt";
import { SelectChangeEvent } from "@mui/material";

function useWidthSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const width = useStore((state) => state.quote.unitSize);
  const fraction = useStore((state) => state.quote.unitSizeFraction);

  const overall = fractionToInt(width, fraction);

  const unitSizeFraction = !fraction ? "0" : fraction;

  const handleError = useStore((state) => state.handleError);

  const errors = useStore((state) => state.errors);

  useEffect(() => {
    const max = 95;
    const min = 13;

    const message =
      overall > max
        ? `Width can not exceed ${max}"`
        : overall < min
        ? `Width must exceed ${min}"`
        : "";

    handleError("widthErr", message);
  }, [overall]);

  const handleWidthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    addToQuote({ unitSize: value }, "unitSize");
  };

  const handleFractionChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    const fractionVal = value === null ? "" : value;
    addToQuote({ unitSizeFraction: fractionVal });
  };

  return {
    handleFractionChange,
    handleWidthChange,
    widthErr: errors.widthErr,
    unitSizeFraction,
    width,
  };
}

export default useWidthSelector;
